<h2 matDialogTitle class="mat-h2">Preview Ad</h2>

<mat-dialog-content style="max-height: unset">
  <mat-divider></mat-divider>
  @if (merchantAd.ad_type === 'banner') {
    <div class="ad-title">{{merchantAd.merchant.merchant_name}}: <i>{{merchantAd.ad_title}}</i></div>
    <img [ngSrc]="merchantAd.image_url" width="{{merchantAd.image_width}}" height="{{merchantAd.image_height}}">
    <div class="wash-out" style="text-align: center">Banner {{merchantAd.image_width}}x{{merchantAd.image_height}}</div>
  } @else if (merchantAd.ad_type === 'text') {
    <div class="ad-title">Ad will display as shown below</div>
    <div class="text-ad-details">
      <a [href]="merchantAd.destination_url" target="_blank">{{merchantAd.link_text}}</a>
    </div>
  }
  @if (($currentAccountEntityGroup | async) === 'merchants') {
    <div class="single-button-group">
      <button mat-raised-button cdkFocusInitial color="primary" matDialogClose>Got It</button>
    </div>
  } @else if (($currentAccountEntityGroup | async) === 'affiliates') {
    <div class="button-group">
      <button mat-button class="cancel-button" matDialogClose>Close</button>
      <button mat-raised-button cdkFocusInitial color="primary" [matDialogClose]="'getLink'">Get Link</button>
    </div>
  }
</mat-dialog-content>
